import { libxConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const addLibxProductToCollection = (productId: string): Promise<void> => {
    const pathParams = {
        action: 'add',
        id: productId
    };

    return http.post(libxConfig().endpointCollection, {}, { pathParams });
};
